import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const listConversations = async (args?: ParamsProps) => {
  const response = await request({
    url: "chat/conversations",
    method: "get",
    authorization: true,
    params: args?.params,
  });
  return response;
};

const getConversation = async (conversationId: number) => {
  const response = await request({
    url: `chat/conversations/${conversationId}`,
    method: "get",
    authorization: true,
  });
  return response;
};

const listMessages = async (conversationId: number, params?: any) => {
  const response = await request({
    url: `chat/conversations/${conversationId}/messages`,
    method: "get",
    authorization: true,
    params,
  });
  return response;
};

const startGeneralChat = async (participantId: number, role: string) => {
  const response = await request({
    url: "chat/conversations/general",
    method: "post",
    authorization: true,
    data: { 
      targetType: role === "admin" ? "admin" : "user", 
      targetId: participantId,
      targetRole: role
    },
  });
  return response;
};

const startOrderChat = async (orderId: number, targetRole?: string) => {
  const response = await request({
    url: "chat/conversations/order",
    method: "post",
    authorization: true,
    data: { orderId, ...(targetRole && { targetRole }) },
  });
  return response;
};

const startSupportChat = async (subject?: string) => {
  const response = await request({
    url: "chat/conversations/support",
    method: "post",
    authorization: true,
    data: { subject },
  });
  return response;
};

const markAsRead = async (conversationId: number) => {
  const response = await request({
    url: `chat/conversations/${conversationId}/read`,
    method: "post",
    authorization: true,
  });
  return response;
};

const sendMessage = async (conversationId: number, data: { content?: string, type?: string, files?: any[] }) => {
  let requestData: any = data;

  if (data.files && data.files.length > 0) {
    const formData = new FormData();
    if (data.content) formData.append('content', data.content);
    if (data.type) formData.append('type', data.type);
    
    data.files.forEach((file, index) => {
      formData.append('files', file);
    });
    requestData = formData;
  }

  const response = await request({
    url: `chat/conversations/${conversationId}/messages`,
    method: "post",
    authorization: true,
    data: requestData,
    headers: requestData instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
  });
  return response;
};

const uploadFile = async (data: FormData) => {
  const response = await request({
    url: "chat/upload",
    method: "post",
    authorization: true,
    data,
  });
  return response;
};

const getUnreadCounts = async () => {
  const response = await request({
    url: "chat/unread",
    method: "get",
    authorization: true,
  });
  return response;
};

export default {
  listConversations,
  getConversation,
  listMessages,
  startGeneralChat,
  startOrderChat,
  startSupportChat,
  markAsRead,
  sendMessage,
  uploadFile,
  getUnreadCounts,
};
